import React, { useMemo, type PropsWithChildren } from 'react';
import { createMemoryHistory, type MemoryHistory } from 'history';

import type { DynamicRouteBrowserHistory, Plugin, Routes } from './common/types.tsx';
import { Router } from './Router.tsx';

export type MemoryRouterProps = PropsWithChildren<{
	basePath?: string;
	isLazyRoutes?: boolean;
	location?: string;
	plugins?: Plugin[];
	routes: Routes;
}>;

export function MemoryRouter(props: MemoryRouterProps) {
	const history = useMemo(
		() =>
			createMemoryHistory(
				props.location ? { initialEntries: [props.location] } : {},
			) as MemoryHistory & DynamicRouteBrowserHistory,
		[props.location],
	);

	return <Router {...props} history={history} isGlobal={false} plugins={props?.plugins ?? []} />;
}
